import { localAESStorage } from '@shared/utils/storage';
import { LSK } from '@shared/utils/storage/config';
import { langReplaceUrl } from '@shared/i18n/route';

import { isUrlReg } from '../reg';
import { getUrlParam } from './param';

export const stratifyUrl = (text: string) => {
	const urlRegex = isUrlReg;
	let url = urlRegex.exec(text);
	const result = [];
	// 当识别到是 url 时，进入循环 处理 url
	while (url) {
		// console.log( 'url', url)
		result.push({ isUrl: false, text: text.substring(0, url.index) });
		result.push({ isUrl: true, text: url[0] });
		text = text.substring(url.index + url[0].length);
		url = urlRegex.exec(text);
	}
	// 剩下的内容 判断为 TEXT
	result.push({ isUrl: false, text: text });
	return result;
};

/**
 * 跨页面携带数据
 */

const TEMPLATE_DATA = LSK.TEMPLATE_APP_PARAMS_DATA;

export function saveAppParams(data: string) {
	localStorage.setItem(TEMPLATE_DATA, data);
}

export function loadAppParams() {
	const data = localStorage.getItem(TEMPLATE_DATA);
	if (data) {
		localStorage.removeItem(TEMPLATE_DATA);
		return data;
	}
}

/**
 * 跨页面携带埋点数据
 */

const TRACK_DATA = LSK.EVENT_TRACKING_DATA;

export function saveTrackingParams(data: any) {
	localStorage.setItem(TRACK_DATA, data);
}

export function loadTrackingParams() {
	const data = localStorage.getItem(TRACK_DATA) || '';
	if (data) {
		localStorage.removeItem(TRACK_DATA);
		return data;
	}
}

/**
 * 删除 路由的某个search 数据
 */
export function deleteSearchKey(searchKey: string) {
	if (!getUrlParam(searchKey)) return;
	const search = location.search;
	const afterFilterSearch = search
		.split('?')[1]
		.split('&')
		.filter((item) => {
			return item.indexOf(searchKey) == -1;
		})
		.join('&');
	const searchParams = afterFilterSearch ? '?' + afterFilterSearch : afterFilterSearch;
	langReplaceUrl({}, '', `${location.pathname + searchParams}`);
}

/**
 * 清理 invitation 数据
 */
export function clearInvitationData() {
	deleteSearchKey('invitation');
	localAESStorage.removeItem(LSK.INVITE_CODE_MAP);
}
